import React from 'react';
import Tile from './Tile';

type TileSelection = {
  id: number;
  title: string;
  description: string;
  icon: React.ReactNode;
  footer: string;
};

type TileContainerProps = {
  onClick: (tile: TileSelection) => void;
};

const tileData: TileSelection[] = [
  {
    id: 1,
    title: 'Manage KPIs',
    description: 'Define, track, and organise the metrics that matter most.',
    icon: <img src="/Manage_kpi.png" alt="Manage KPIs" className="w-5 h-5" />,
    footer: 'Manage KPIs',
  },
  {
    id: 2,
    title: 'Get Insights / Benchmarks',
    description: 'Explore sector and peer-group ranges for key KPIs across industries.',
    icon: <img src="/Get_Benchmarks.png" alt="Get Insights / Benchmarks" className="w-5 h-5" />,
    footer: 'Explore Insights',
  },
  {
    id: 3,
    title: 'Compare a Company',
    description: 'Measure a company against relevant peers across multiple dimensions without contributing to dataset.',
    icon: <img src="/Compare_a_Company.png" alt="Compare a Company" className="w-5 h-5" />,
    footer: 'Start Comparing',
  },
];

const TileContainer = ({ onClick }: TileContainerProps) => {
  return (
    <div className="min-h-screen bg-[#f4fbf6] dark:bg-gray-950 relative overflow-hidden">
      <div className="pointer-events-none absolute -top-32 -left-32 w-[520px] h-[520px] rounded-full bg-emerald-200/30 blur-3xl" />
      <div className="pointer-events-none absolute -top-40 -right-32 w-[440px] h-[440px] rounded-full bg-sky-200/25 blur-3xl" />
      <div className="pointer-events-none absolute bottom-40 right-1/4 w-[380px] h-[380px] rounded-full bg-indigo-200/20 blur-3xl" />

      <div className="relative z-10">
        <div className="text-center py-16">
          <h2 className="text-4xl font-bold text-green-600 dark:text-white mb-3 tracking-tight">Welcome!</h2>
          <p className="text-lg text-black-600 dark:text-gray-300 max-w-2xl mx-auto">Select what you would like to do.</p>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {tileData.map((tile) => (
              <Tile
                key={tile.id}
                icon={tile.icon}
                title={tile.title}
                description={tile.description}
                footer={tile.footer}
                onClick={() => onClick(tile)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TileContainer;